import * as S from './styles.ts';
import { Slider, IncrementButton } from '@template/components';
import useBreakpoint from '@/lib/helpers/hooks/useBreakpoint.ts';

interface ISliderProps {
  value: number;
  setValue: (value: number) => void;
  showInput?: boolean;
  showSlider?: boolean;
}

const UserCount = ({
  value,
  setValue,
  showInput,
  showSlider,
}: ISliderProps) => {
  const { check: isBig, mounted } = useBreakpoint('sm');

  const handleValue = (val: number) => {
    const min = 1;
    const max = 150;
    return Math.min(Math.max(val, min), max);
  };

  if (!showSlider && !showInput) return;

  return (
    <S.SliderContainer>
      {showInput && (
        <IncrementButton
          value={value}
          setValue={(val) => setValue(handleValue(val))}
        />
      )}
      {isBig && mounted && showSlider && (
        <Slider
          value={value}
          onChange={setValue}
          min={1}
          max={150}
          step={1}
          breaks={[20, 100]}
          showNumbers
          startText='1 User'
          showValue
        />
      )}
    </S.SliderContainer>
  );
};

export default UserCount;
